import {deleteCookie} from "./Utils"

export const gaInit = gaId => {
  document.addEventListener(
    "consent-analytics",
    function (e) {
      if (e.detail.status) {
        // gaGrant(gaId)
      } else {
        gaRevoke()
      }
    },
    false
  )
}

const gaGrant = gaId => {
  gtag("js", new Date())
  gtag("config", gaId)
}

const gaRevoke = gaId => {
  deleteCookie("_ga")
  deleteCookie("_gat")
  deleteCookie("_gid")
  deleteCookie(`_gat_gtag_${gaId}`)
}
